<template>
    <ValidationProvider        
        name="textfield"
        :rules="checkForValidation(item)"
        v-slot="{ errors }"
        slim
    >
        <v-text-field
            :value="item.value !== null ? item.value : item.default"
            :label="$t(item.name)"
            @change="changeValue($event, item)"
            :id="'textfield-'+item.id"
            :error-messages="errors"
            :alvqa="alvqa"
        ></v-text-field>
    </ValidationProvider>
</template>

<script>
export default {
    name: "SettingsTextfield",
    props: {
        item: Object,
        alvqa: String
    },
    methods: {
        changeValue(newValue, item) {
            item.value = newValue
        },
        checkForValidation(item) {
            if(item.validation === '') return item.validation
            else {
                let arr = item.validation.split(' ')
                let rules = arr.join('|')
                return rules
            }
        }
    }
}
</script>